import type { DataSourceListRequest } from '@/entities/datasource/domain/types';

export const datasourceKeys = {
  all: ['datasource'] as const,
  list: (params: DataSourceListRequest) => [...datasourceKeys.all, 'list', params.maturity] as const,
} as const;
